import React, { useState } from 'react';
import { Tabs } from 'antd';
import AddAwards from './AddAwards'
import UpdateAwards from './UpdateAwards'
import DownloadRewardsReport from '../Organism/DownloadRewardsReport';

const RewardsPage: React.FC = () => {
  const [activeKey, setActiveKey] = useState('1');

  const onTabChange = (key: string) => {
    setActiveKey(key);
  };

  return (
    <Tabs activeKey={activeKey} onChange={onTabChange}>
      <Tabs.TabPane tab="Add New Rewards" key="1">
        <AddAwards />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Update Existing Rewards" key="2">
        <UpdateAwards />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Download Awards Report" key="3">
        <DownloadRewardsReport />
      </Tabs.TabPane>
    </Tabs>
  );
};

export default RewardsPage;